//==============================================================================
// Set Customer Match Email
//
// Sets the email on a customer record after successful customer match, but only
// if customer record has no existing email.
//==============================================================================
import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { QueryResultSettingsProxy } from '@msdyn365-commerce-modules/retail-actions';

import { setCustomerMatchEmailAsync } from '../../../actions/DataActionExtension.g';
import { ICustomerMatchEmailInformation, ICustomResponse_1OfBoolean } from '../../../actions/DataServiceEntities.g';

//==============================================================================
// FUNCTIONS
//==============================================================================
//==========================================================
// SetCustomerMatchEmail Input Action
//==========================================================
export class SetCustomerMatchEmailInput implements IActionInput {
    public setEmailInfo: ICustomerMatchEmailInformation;

    //------------------------------------------------------
    // Constructor
    //------------------------------------------------------
    constructor(setEmailInfo: ICustomerMatchEmailInformation) {
        this.setEmailInfo = setEmailInfo;
    }

    //------------------------------------------------------
    // Caching
    //------------------------------------------------------
    public getCacheKey = () => 'SetCustomerMatchEmail';
    public getCacheObjectType = () => 'SetCustomerMatchEmail';
    public dataCacheType = (): CacheType => 'none';
}

//==========================================================
//==========================================================
async function setCustomerMatchEmailAction(input: SetCustomerMatchEmailInput, ctx: IActionContext): Promise<ICustomResponse_1OfBoolean> {
    return setCustomerMatchEmailAsync(
        {
            callerContext: ctx,
            queryResultSettings: QueryResultSettingsProxy.getPagingFromInputDataOrDefaultValue(ctx)
        },
        input.setEmailInfo
    ).then(result => {
        return result;
    }).catch(error => {
        ctx.telemetry.exception(error.message);
        ctx.telemetry.debug('Unable to set customer match email');
        throw new Error('Unable to set customer match email');
    });
}

//==============================================================================
//==============================================================================
export const setCustomerMatchEmailActionDataAction = createObservableDataAction<ICustomResponse_1OfBoolean>({
    id: 'set-customer-match-email',    // This can be anything EXCEPT the data action path ('actions/set-customer-match-email')
    action: <IAction<ICustomResponse_1OfBoolean>>setCustomerMatchEmailAction
});

export default setCustomerMatchEmailActionDataAction;
